export default __webpack_public_path__ + "img/cVPPdKGk.c5bf2d6f.svg";